import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { CoachSummary } from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';
import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

export const useAgentContext = (coaches: readonly CoachSummary[]) => {
  useRegisterAgentContext({
    kind: 'list',
    description: 'The coaches assigned to this student, shown on their profile.',
    data: coaches.map((coach) => ({
      id: coach.id,
      name: personName(coach),
      headline: coach.headline,
      job_title: coach.job_title,
    })),
  });
};
